import ReactApexChart from "react-apexcharts";
import React, {  }  from 'react';
function Chart(props) {
  const { type="area" ,chartData, chartOptions, ...rest } = props;
  return (
    <ReactApexChart
        options={chartOptions}
        series={chartData}
        type={type}
        width="100%"
        height="100%"
      />
  );
}

export default Chart;
